<script>
  export default {
    name: 'ModalVue',
    methods: {
      close() {
        this.$emit('close');
      },
      updateHeight() {
        this.componentHeight = this.$refs.component.offsetHeight;
      }
    }, 
    
    data() {
      return {
        componentHeight: 0
      };
    },
    computed: {
      calculatedMargin() {
        return `calc(50vh - ${this.componentHeight / 2}px)`;
      }
    },
    mounted() {
      this.componentHeight = this.$refs.component.offsetHeight;
      window.addEventListener("resize", this.updateHeight);
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.updateHeight);
    },

  };
</script>

<template>
  <transition name="modal-fade">
    <div class="approval-modal-backdrop" @click.self="close">
      <div class="approval-modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
        ref="component"  
      >
        <header
          class="modal-headerr"
          id="modalTitle"
        >
          <slot name="header">
            This is the default tile!
          </slot>
         
        </header>

        <section
          class="modal-body"
          id="modalDescription"
        >
          <slot name="body">
            This is the default body!
          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.approval-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  justify-content: center;
  overflow-y: auto; /* enable scrolling when modal or content is taller than viewport */
  -webkit-overflow-scrolling: touch;
}
.approval-modal {
  background: #FFFFFF;
  box-shadow: 2px 2px 20px 1px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  width: 90%;
  margin-top: 10vh; /* default margin for smaller screens */
  max-width: 800px;
  max-height: calc(100vh - 120px); /* leave some space above/below */
  padding: 20px;
  z-index: 1001;
  border-radius: 8px;
  overflow-y: auto; /* important: allow vertical scrolling inside modal */
  box-sizing: border-box;
}


  .modal-header {
    padding: 15px;
    display: flex;
    gap: 10px;
  }

  .modal-headerr {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #000;
    justify-content: space-between;
    padding: 10px 10px 10px 20px;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 13px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #000000;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #000000;
    border: 1px solid #000000;
    border-radius: 2px;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>